import React from 'react';
import * as _ from 'lodash';

import { CompanyService } from '../../../services/Companies';
import {
  DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT,
  REQUEST_PARAMS
} from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';

import { RadioButtonIcon } from '../../icons/RadioButtonIcon';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import '../../../styles/organisms/jv-company.scss';

export class JvCompanyDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false, // コンポーネント開閉フラグ
      list: [], // JV会社情報
      searchWord: '', // 検索ワード
      selected: {
        id: this.props.id, // 選択ID
      },
      isLoading: false, // ロード中フラグ
    };

    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    ); // コンポーネント外クリック判定メソッド
    this.clearSelectedRow = this.clearSelectedRow.bind(this);
    this.parent = React.createRef();
    this.searchTimer;
  }

  componentDidMount() {
    if (!_.isUndefined(this.state.selected.id)) {
      // JV会社が登録されていた場合
      this.getJvCompanyList(this.props.value);
    }
  }

  componentDidUpdate() {
    if (this.state.show === true) {
      // コンポーネントが可視状態の場合、clickイベントをセット
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.show === false) {
      // コンポーネントが不可視状態の場合、clickイベントを削除
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isUndefined(this.state.selected.id) && _.isUndefined(nextProps.id)) {
      // 削除したJV会社の次の行にJV会社が設定されていない場合、
      // JV会社を削除
      this.setState({
        list: [],
        selected: {},
      });
    } else if (
      !_.isUndefined(this.state.selected.id) &&
      !_.isUndefined(nextProps.id) &&
      this.state.selected.id !== nextProps.id
    ) {
      // 削除したJV会社の次の行に異なるJV会社が設定されている場合、
      // 次の行のJV会社を設定
      const selected = {
        id: nextProps.id,
        name: nextProps.value,
        company_branches: nextProps.companyBranches,
      };
      this.setState({ selected });
      this.getJvCompanyList(nextProps.value);
    }
  }

  /**
   * @description JV会社情報取得
   * @param {string} searchWord 検索ワード
   */
  getJvCompanyList(searchWord) {
    let list = [];
    const params = {
      company_branch_id: this.props.companyBranchId,
      name: searchWord,
      offset: 0,
      limit: REQUEST_PARAMS.parentLimit,
    };

    CompanyService.jvCompanyList(params).then(resp => {
      if (resp.result) {
        list = resp.data.entities.company;
      }
      this.setState({ list, isLoading: false });
    });
  }

  /**
   * @description JVコンポーネントの開閉状態を設定
   */
  handleShowForm() {
    if (this.props.disabled !== true) {
      // 詳細画面ではない場合
      this.setState({ show: !this.state.show });
    }
  }

  /**
   * @description クリックした場所を判定
   */
  handleClickOutsideOfComponent(e) {
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      // コンポーネント内クリックの場合
      return;
    }
    // コンポーネント外クリックの場合、コンポーネントを不可視にする
    this.setState({ show: false });
  }

  handleSelectedRow = id => {
    let selected = {};
    if (this.state.selected.id !== id) {
      selected = _.find(this.state.list, item => {
        return item.id === id;
      });
      this.setState({ selected }, () => {
        this.selectItem();
      });
    }
  };

  clearSelectedRow = () => {
    // TODO
  };

  /**
   * @description 検索ワードを設定
   * @param {string} searchWord 検索ワード
   */
  inputSearchWord(searchWord) {
    this.setState({ searchWord }, () => {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.searchJVbySearchWord(true);
      }, DROPDOWN_SEARCH_DEBOUNCE_TIMEOUT);
    });
  }

  /**
   * @description 検索ワードでJV会社を検索
   */
  searchJVbySearchWord(loadingFlag) {
    this.setState({ isLoading: loadingFlag }, () => {
      this.getJvCompanyList(this.state.searchWord);
    });
  }

  /**
   * @description コンポーネント内アイテムセット
   */
  setItems() {
    if (_.isEmpty(this.state.list)) {
      return (
        <div className='table-has-no-data'>
          <div className='table-has-no-data__message'>
            {messageUtility.getMessage('I-000-046')}
          </div>
        </div>
      );
    }
    return _.map(this.state.list, (item, index) => (
      <li key={index} className='single-select__item '>
        <label
          className='radio'
          htmlFor={`dropdown-${this.props.index}-${item.id}`}
        >
          <input
            id={`dropdown-${this.props.index}-${item.id}`}
            type='radio'
            checked={this.state.selected.id === item.id}
            onChange={() => {
              this.handleSelectedRow(item.id);
            }}
          />
          <RadioButtonIcon className='icon--1_6x' />
          <span className='single-select__label-text'>{item.name}</span>
        </label>
      </li>
    ));
  }

  /**
   * @description コンポーネント内アイテム選択
   */
  selectItem() {
    if (!_.isUndefined(this.state.selected.id)) {
      // JV会社を選択している場合
      this.props.onUpdate(this.state.selected);
    }
    this.setState({ show: false, searchWord: '' });
  }

  render() {
    const getDropdownLabel = () => {
      let label = !_.isUndefined(this.props.value)
        ? this.props.value
        : '会社を指定';
      return label;
    };
    return (
      <div className='dropdown-single-select dropdown-single-select__jv-company' ref={this.parent}>
        <div
          className={`dropdown-single-select__header ${
            this.state.show && 'show'
          }`}
        >
          <div
            className={`dropdown-select${
              this.props.disabled ? '--disabled' : ''
            }`}
            onClick={() => this.handleShowForm()}
          >
            <span className='dropdown-select__txt'>{getDropdownLabel()}</span>
            <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
          </div>
        </div>
        {this.state.show && (
          <div
            id='form-dropdown-list'
            className='dropdown dropdown--dropdown-list show'
          >
            <div className='dropdown__item dropdown__item--hidden'>
              <div className='dropdown-single-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  value={this.state.searchWord}
                  className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                  placeholder={messageUtility.getMessage('I-000-090')}
                  onChange={e => this.inputSearchWord(e.target.value)}
                />
              </div>
              {/* TODO:FieldFormElementsでJV項目をクリアする方法がまだないため
            <div className='dropdown-single-select__item'>
              <button
                className='btn--sub btn--icon btn--filled'
                onClick={this.clearSelectedRow}
              >
                <ClearIcon className='icon--2x' />
                選択を解除する
              </button>
            </div> */}
              <div className='dropdown-single-select__scroll'>
                <ul className='single-select'>
                  {this.state.isLoading ? (
                    <div className='indicator' />
                  ) : (
                    <React.Fragment>{this.setItems()}</React.Fragment>
                  )}
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/JvCompany.jsx